export default "__VITE_ASSET__BtNfT7dl__"